<template>
  <div>
    <div class="logo-image"></div>
    <div class="md-layout text-center">
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-card>
          <md-card-content>
            <div class="center-content">
              <h4 class="bold-header">This email is not authorized to access the application</h4>
              <h5>Please contact your business responsible regarding your account creation</h5>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    document.documentElement.style.setProperty(
      "--pz-background-image-url",
      "url(/img/background.jpg)"
    );
    document.documentElement.style.setProperty(
      "--pz-logo-image-url",
      "url(/img/logo-default.png)"
    );
    document.documentElement.style.setProperty(
      "--pz-logo-image-background-position-y",
      "bottom"
    );
  }
};
</script>
<style scoped>
.center-content {
  text-align: center;
}
.bold-header {
  font-weight: 600;
}

.logo-image{
  margin-left: 30px;;
  padding-top: 30px;;
}
</style>
